/**
 * Webpage with settings for the Request
 */
import accounting from 'accounting';
import React, {useEffect, useRef, useState} from "react";
import loader from "../img/loader.gif";
import L from "leaflet";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from "moment"
import {useNavigate} from 'react-router-dom';
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from 'primereact/multiselect';


require('moment-precise-range-plugin')

const OutdoorPlaningCalculation = ({getArea, setJson}) => {
    // called after the render function to alter the webpage
    //const [checked, setChecked] = useState(false);
    const history = useNavigate();
    var checkbox = useRef();
    var area = getArea();
    var polygon = JSON.parse(localStorage.getItem("polygon"));
    let dates = useRef([new Date(), new moment().add(10, 'years').subtract(1, 'day').toDate()]);
    if (localStorage.getItem("timeRange") !== null) {
        let rangeStrings = JSON.parse(localStorage.getItem("timeRange"));
        dates.current = [new Date(rangeStrings[0]), new Date(rangeStrings[1])];
    }
    const antennas = ["Rundstrahler", "Sektorantenne"]
    const azimuths = ["0", "30", "60", "90", "120", "150", "180", "210", "240", "270", "300"]
    const [timeRange, timeRangeChange] = useState(dates.current);
    const [model, setModel] = useState("Empirisch (Obstacle Shadowing nach ITU-R P.2040-3)");
    const [selectedAntennas, setSelectedAntennas] = useState(["Rundstrahler"]);
    const [selectedAzimuths, setSelectedAzimuths] = useState(["0"]);
    useEffect(() => {
        /**
         * setting the next Button to be disabled until the urban/rural percentages are calculated
         */
        if (!document.getElementById("map").firstChild) {
            var map = L.map('map', {
                center: [0, 0],
                zoom: 0,
            });
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                minZoom: 6,
                maxNativeZoom: 18,
                maxZoom: 20,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            }).addTo(map);
            let outerPolygon = L.polygon(polygon, {color: '#6c757d', fill: true}).addTo(map)
            //var output = String(area).replace('.', ',') + " km<sup>2</sup>";
            // outerPolygon.bindTooltip(output, {
            //     permanent: true,
            //     className: 'polygon-tooltip'
            // });
            map.fitBounds(outerPolygon.getBounds())
            if (localStorage.getItem("calc") === "true") {
                const next = document.getElementById('next')
                next.onclick = () => {
                }
                next.classList.add('fa-disabled');
                next.classList.remove('hover');
                next.style.pointerEvents = "none";
                const back = document.getElementById('back')
                back.classList.add('fa-disabled');
                back.onclick = () => {
                };
                back.style.pointerEvents = "none";
                back.classList.remove('hover');
                var loaderIcon1 = document.getElementById('loader1');
                loaderIcon1.style.visibility = "visible";
                var loaderIcon2 = document.getElementById('loader2');
                loaderIcon2.style.visibility = "visible";
                areaRequest()
            } else {
                const next = document.getElementById('next')
                next.classList.remove('fa-disabled');
                next.style.pointerEvents = "auto";
                next.classList.add('hover');
                const back = document.getElementById('back')
                back.classList.remove('fa-disabled');
                back.style.pointerEvents = "auto";
                back.classList.add('hover');
                back.onclick = () => history(-1);
            }
            var json = JSON.parse(localStorage.getItem("json"))
            fillForm(json)
        }
        // console.log(document.getElementById("model"))
    })
    useEffect(() => {
        createJson()
        if (selectedAntennas.length === 0 || localStorage.getItem("calc") === "true") {
            const next = document.getElementById('next')
            next.classList.remove('hover');
            next.classList.add('fa-disabled');
            next.style.pointerEvents = "none";
        } else {
            const next = document.getElementById('next')
            next.classList.remove('fa-disabled');
            next.style.pointerEvents = "auto";
            next.classList.add('hover');
        }
    }, [selectedAntennas, selectedAzimuths])

    accounting.settings = {
        currency: {
            symbol: "€",
            format: "%v %s",
            decimal: ",",
            thousand: ".",
            precision: 2
        },
        number: {
            precision: 0,
            thousand: ",",
            decimal: "."
        }
    }
    /**
     * Setting default values
     */
    const BNETZA_MAX_T_26G = new Date(2040, 11, 31)
    var today = new Date(Date.now())
    //var years_between = BNETZA_MAX_T_26G.getFullYear() - today.getFullYear()
    //var months_between = (years_between * 12) + (BNETZA_MAX_T_26G.getMonth() - today.getMonth())
    //var max_t_26G = (months_between / 12)
    //max_t_26G = max_t_26G - (max_t_26G % 0.25)
    const freqSettings = {
        "3,7-3,8 GHz": {
            "B": {
                "htmlElem": "bandwidth",
                "min": "10",
                "max": "100",
                "step": "10",
                "value": "100"
            },
        },
        "26 GHz": {
            "B": {
                "htmlElem": "bandwidth",
                "min": "200",
                "max": "3200",
                "step": "200",
                "value": "200"
            }
        }
    }
    // const models = ["Empirisch (Obstacle Path Model)"] // ["Machine Learning-basiert (DRaGon)", ]
    // const models = ["Machine Learning-basiert (DRaGon)", "Empirisch (Obstacle Shadowing nach ITU-R P.2040-3)", "Empirisch (Obstacle Shadowing OPAR)", "Empirisch (Obstacle Shadowing nach Sommer et al.)"]
    const models = ["Machine Learning-basiert (DRaGon)", "Empirisch (Obstacle Shadowing Concrete nach ITU-R P.2040-3)", "Empirisch (Obstacle Shadowing Brick nach ITU-R P.2040-3)", "Empirisch (Obstacle Shadowing Plasterboard nach ITU-R P.2040-3)", "Empirisch (Obstacle Shadowing OPAR)", "Empirisch (Obstacle Shadowing nach Sommer et al.)"]

    function fillForm(json) {
        if (json !== null) {
            // document.getElementById('frequency').value = json["frequency"]
            // frequencyChooserChanged()
            if (json["bandwidth"] === "auto") {
                checkbox.current.checked = true;
            } else {
                checkbox.current.checked = false;
                document.getElementById("B").value = json["bandwidth"];
            }
            if (json["frequency"] === "26 GHz") {
                document.getElementById('blocksize_26GHz').value = json["blocksize"]
            } else {
                document.getElementById('blocksize_3GHz').value = json["blocksize"]
            }
            document.getElementById("a1").value = json["a1"]
            document.getElementById("a2").value = json["a2"]
            document.getElementById("EIRP").value = json["EIRP"]
            document.getElementById("model").value = json["model"]
            setSelectedAntennas(json["antennatype"])
            setSelectedAzimuths(json["azimuth"])
            // document.getElementById("grenzwert").value = json["grenzwert"]
            // document.getElementById("grenzwert_value").innerText = json["grenzwert"]
            document.getElementById("baseStations").value = json["baseStations"]

        }
        disableBandwidth()
        checkBandwidthExceedance()
    }

    /**
     * onChange functions
     */
    function a1Changed() {
        var a1 = document.getElementById("a1").value;
        if (a1 > 100) {
            a1 = 100;
        }
        if (a1 < 0) {
            a1 = 0;
        }
        document.getElementById("a1").value = a1;

        var a2 = Math.round((100 - a1) * 10) / 10;
        document.getElementById("a2").value = a2;
        calculateCost();
    }

    function a2Changed() {
        var a2 = document.getElementById("a2").value;
        if (a2 > 100) {
            a2 = 100;
        }
        if (a2 < 0) {
            a2 = 0;
        }
        document.getElementById("a2").value = a2;
        var a1 = Math.round((100 - a2) * 10) / 10;
        document.getElementById("a1").value = a1;
        calculateCost();
    }

    /**
     * Calculating the costs based on the current settings
     */
    function calculateCost() {
        document.getElementById("area").innerHTML = area;
        var B = document.getElementById("B").value;
        let momentDates = [moment(dates.current[0].toISOString()), moment(dates.current[1].toISOString()).add(1, "days")];
        let diff = moment.preciseDiff(momentDates[0], momentDates[1], true)
        if (diff.months === 0 && diff.years === 0) {
            var ZAntDays = Math.abs(Math.ceil((dates.current[0].getTime() - today.getTime()) / (1000 * 3600 * 24)));
            var ZAnt = 4;
            var A = 3;
            if (ZAntDays >= 15) {
                ZAnt = 1;
            } else if (ZAntDays >= 4) {
                ZAnt = 2;
            } else if (ZAntDays >= 1) {
                ZAnt = 3;
            }
            if (area <= 10) {
                A = 1;
            } else if (area < 10000) {
                A = 2;
            }
            document.getElementById("kosten").innerHTML =
                accounting.formatMoney(Math.round(30 * A * ZAnt));
        } else {
            let months = diff.months
            if (diff.days > 0) {
                months += 1;
            }
            var t = diff.years
            var a1 = document.getElementById("a1").value;
            var a2 = document.getElementById("a2").value;

            var chosenFreq = "3,7-3,8 GHz" //document.getElementById('frequency').value
            var freqFactor = -1
            if (chosenFreq === "3,7-3,8 GHz") {
                freqFactor = 5
            }
            if (chosenFreq === "26 GHz") {
                freqFactor = 0.63
            }
            if (area !== 0) {
                if (checkbox.current.checked) {
                    if (chosenFreq === "3,7-3,8 GHz") {
                        let minPatrial = (Math.round((1000 + 10 * 1 * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100) * (months / 12);
                        let maxPatrial = (Math.round((1000 + 100 * 1 * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100) * (months / 12);
                        let min = diff.years === 0 ? accounting.formatMoney(minPatrial) : accounting.formatMoney(minPatrial + Math.round((1000 + 10 * t * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100);
                        let max = diff.years === 0 ? accounting.formatMoney(maxPatrial) : accounting.formatMoney(maxPatrial + Math.round((1000 + 100 * t * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100);
                        document.getElementById("kosten").innerHTML = min + " - " + max;
                    } else {
                        let minPatrial = (Math.round((1000 + 50 * 1 * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100) * (months / 12);
                        let maxPatrial = (Math.round((1000 + 800 * 1 * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100) * (months / 12);
                        let min = diff.years === 0 ? accounting.formatMoney(minPatrial) : accounting.formatMoney(minPatrial + Math.round((1000 + 50 * t * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100);
                        let max = diff.years === 0 ? accounting.formatMoney(maxPatrial) : accounting.formatMoney(maxPatrial + Math.round((1000 + 800 * t * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100);
                        document.getElementById("kosten").innerHTML = min + " - " + max;
                    }
                } else {
                    let partial = (Math.round((1000 + B * 1 * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100) * (months / 12);
                    document.getElementById("kosten").innerHTML = diff.years === 0 ? accounting.formatMoney(partial) : accounting.formatMoney(partial + Math.round((1000 + B * t * freqFactor * (((6 * a1) / 100) * area + (a2 / 100) * area)) * 100) / 100)
                }
            }
        }
        createJson()
    }

    function blocksizeChooser26GChanged() {
        var chosenFreq = "3,7-3,8 GHz" //document.getElementById('frequency').value
        var blocksizeChooser26G = document.getElementById('blocksize_26GHz')
        if (chosenFreq === "26 GHz") {
            var chosenBlockSize26G = blocksizeChooser26G.value
            var bandwidthSettings26G = freqSettings["26 GHz"]["B"]

            bandwidthSettings26G["min"] = chosenBlockSize26G
            bandwidthSettings26G["step"] = chosenBlockSize26G
            bandwidthSettings26G["value"] = chosenBlockSize26G
        }
    }

    function frequencyChooserChanged() {
        var chosenFreq = document.getElementById('frequency').value
        var freqSetting = freqSettings[chosenFreq]
        var blocksizeChooser26G = document.getElementById('blocksize_26GHz')
        var blocksizeChooser3G = document.getElementById('blocksize_3GHz')

        if (chosenFreq === "26 GHz") {
            blocksizeChooser26G.style.display = "block";
            blocksizeChooser3G.classList.remove("d-inline");
            blocksizeChooser3G.classList.add("d-none");
        } else {
            blocksizeChooser26G.style.display = "none";
            blocksizeChooser3G.classList.remove("d-none");
            blocksizeChooser3G.classList.add("d-inline");
        }

        var elems = ["B"]
        for (var i = 0; i < elems.length; i++) {
            var elem = elems[i]
            var elemSettings = freqSetting[elem]
            var htmlElem = document.getElementsByName(elemSettings["htmlElem"])[0];
            htmlElem.min = elemSettings["min"]
            htmlElem.max = elemSettings["max"]
            htmlElem.step = elemSettings["step"]
            htmlElem.value = elemSettings["value"]
        }
    }

    function checkBandwidthExceedance() {
        var bandwidthExceedanceInfo = document.getElementById('bandwidth_exceedance_warning')
        var bandwidth = document.getElementById('B')
        var currentBandwidth = parseInt(bandwidth.value);
        if (currentBandwidth > 800) {
            bandwidthExceedanceInfo.style.display = "block";
        } else {
            bandwidthExceedanceInfo.style.display = "none";
        }
    }

    function checkBandwidthOrTime(input_elem) {
        var chosenFreq = "3,7-3,8 GHz" //document.getElementById('frequency').value
        var val = parseFloat(document.getElementById(input_elem).value);
        var maxVal = parseFloat(freqSettings[chosenFreq][input_elem]["max"])
        var minVal = parseFloat(freqSettings[chosenFreq][input_elem]["min"])
        if (val > maxVal) {
            val = maxVal;
        }
        if (val < minVal) {
            val = minVal;
        }

        var step = parseFloat(freqSettings[chosenFreq][input_elem]["step"])
        var rest = val % step
        if (rest !== 0) {
            val = val - rest

        }
        document.getElementById(input_elem).value = val;
    }

    function checkNumBS() {
        var val = parseFloat(document.getElementById("baseStations").value);
        if (val > 10) {
            val = 10;
        }
        if (val < 1) {
            val = 1;
        }
        document.getElementById("baseStations").value = val;
    }

    /**
     * creating Json file for the Dataset
     */
    function createJson() {
        var json = localStorage.getItem("json") === null ? {} : JSON.parse(localStorage.getItem("json"));

        json["area"] = document.getElementById("area").innerHTML.split(" ")[0];
        if (checkbox.current.checked) {
            json["bandwidth"] = "auto";
        } else {
            json["bandwidth"] = document.getElementById("B").value;
        }
        let timeRangeYear = [dates.current[0].toLocaleDateString(), dates.current[1].toLocaleDateString()]
        json["time"] = timeRangeYear;
        json["a1"] = document.getElementById("a1").value;
        json["a2"] = document.getElementById("a2").value;
        json["blocksize"] = document.getElementById("blocksize_26GHz").style.display === "none" ? document.getElementById("blocksize_3GHz").innerHTML : document.getElementById("blocksize_26GHz").value
        json["frequency"] = "3,7-3,8 GHz" //document.getElementById('frequency').value
        json["price"] = document.getElementById('kosten').innerHTML
        json["polygon"] = polygon
        json["EIRP"] = document.getElementById("EIRP").value
        json["azimuth"] = selectedAzimuths
        //json["grenzwert"] = document.getElementById("grenzwert").value
        json["antennatype"] = selectedAntennas
        json["model"] = document.getElementById("model").value //model
        json["baseStations"] = document.getElementById("baseStations").value
        if (json["priorities"] === undefined)
            json["priorities"] = []
        if (json.datarateDownLink === undefined)
            json.datarateDownLink = 100
        if (json.datarateUpLink === undefined)
            json.datarateUpLink = 50
        setJson(json)


    }

    /**
     * Requesting Area Informations from flask server
     */
    function areaRequest() {
        var coords = convertCoordinatesArray(polygon);
        var coordsStr = coords.join(',');
        var invalid_area_text = document.getElementById('invalid_area');
        var percentage_value;
        var req = new XMLHttpRequest();
        req.onload = function () {
            if (this.readyState === 4 && this.status === 200) {
                if (this.response === 'ERROR') {
                    invalid_area_text.style.display = 'table-row';
                    percentage_value = 0;
                } else {
                    let result = JSON.parse(this.response);
                    invalid_area_text.style.display = 'none';

                    if (result.percentage === 'ERROR') {
                        invalid_area_text.style.display = 'table-row';
                        percentage_value = 0;
                    } else {
                        percentage_value = parseFloat(result.percentage);
                    }
                    delete result.percentage

                    if (result.buildings !== 'ERROR') {
                        localStorage.setItem("buildings", JSON.stringify(result.buildings));
                    }
                }
                document.getElementById("a2").value = Math.round(percentage_value * 10) / 10;
                a2Changed();
                var loaderIcon1 = document.getElementById('loader1');
                loaderIcon1.style.visibility = "hidden";
                var loaderIcon2 = document.getElementById('loader2');
                loaderIcon2.style.visibility = "hidden";
            }
            const next = document.getElementById('next')
            next.classList.remove('fa-disabled');
            next.style.pointerEvents = "auto";
            next.classList.add('hover');
            const back = document.getElementById('back')
            back.classList.remove('fa-disabled');
            back.style.pointerEvents = "auto";
            back.classList.add('hover');
            back.onclick = () => history(-1);
            localStorage.setItem("calc", false);
        }
        req.ontimeout = function (e) {
            invalid_area_text.style.display = 'table-row';
            percentage_value = 0;
            var loaderIcon1 = document.getElementById('loader1');
            loaderIcon1.style.visibility = "hidden";
            var loaderIcon2 = document.getElementById('loader2');
            loaderIcon2.style.visibility = "hidden";
            const next = document.getElementById('next')
            next.classList.remove('fa-disabled');
            next.style.pointerEvents = "auto";
            next.classList.add('hover');
            const back = document.getElementById('back')
            back.classList.remove('fa-disabled');
            back.style.pointerEvents = "auto";
            back.classList.add('hover');
            back.onclick = () => history(-1);

        }
        req.timeout = 100000;
        req.open("GET", "/api/percentageCalc/" + coordsStr, true);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        req.send();

    }

    /**
     * switching order of Long Lat for areae request
     */
    function convertCoordinatesArray(coords) {
        var coords_conv = [];
        coords.forEach(function (coord) {
            coord = [coord.lat, coord.lng];
            coords_conv.push(coord);
        });
        return coords_conv;
    }

    function disableBandwidth() {
        var b = document.getElementById("B");
        var block = document.getElementById("blocksize_26GHz");
        if (checkbox.current.checked) {
            block.disabled = true;
            b.disabled = true;
        } else {
            block.disabled = false;
            b.disabled = false;
        }
        calculateCost();
    }

    function checkMaxDate() {
        //min date immer kleiner als max
        document.getElementById("invalid_timespan").style.display = "none";
        document.getElementById("invalid_timespan_3").style.display = "none";
        document.getElementById("invalid_timespan_26").style.display = "none";
        var chosenFreq = document.getElementById('frequency').value
        if (chosenFreq === "3,7-3,8 GHz") {
            let max10 = new Date(timeRange[0].getFullYear() + 10, timeRange[0].getMonth(), timeRange[0].getDate())
            if (timeRange[1] > BNETZA_MAX_T_26G && max10 > BNETZA_MAX_T_26G) {
                dates.current[0] = timeRange[0]
                dates.current[1] = BNETZA_MAX_T_26G
                timeRangeChange(dates.current)
                document.getElementById("invalid_timespan").style.display = "table-row";
                document.getElementById("invalid_timespan_3").style.display = "block";
            } else if (timeRange[1] > max10) {
                dates.current[0] = timeRange[0]
                dates.current[1] = max10;
                timeRangeChange(dates.current)
                document.getElementById("invalid_timespan").style.display = "table-row";
                document.getElementById("invalid_timespan_3").style.display = "block";
            } else {
                dates.current[1] = timeRange[1]
            }
        } else {
            if (timeRange[1] > BNETZA_MAX_T_26G) {
                dates.current[0] = timeRange[0]
                dates.current[1] = BNETZA_MAX_T_26G;
                timeRangeChange(dates.current)
                document.getElementById("invalid_timespan").style.display = "table-row";
                document.getElementById("invalid_timespan_26").style.display = "block";
            } else {
                dates.current[1] = timeRange[1]
            }
        }
        if (timeRange[0] > timeRange[1]) {
            dates.current[0] = dates.current[1]
            timeRangeChange(dates.current)
        }
    }

    return (
        <div>
            <div className={'text-center'}>
                <div className={' px-lg-3 py-lg-1 d-inline-block bg-secondary text-white rounded-3'}
                     style={{marginTop: "10px"}}>
                    <div className='fs-4'>Konfiguration Ihres 5G-Campusnetzes</div>
                </div>
            </div>
            <div className={"container"} style={{marginTop: "10px", maxWidth: "1450px"}}>
                <div className={"row"}>
                    <div className={"col-6"}>
                        {/*<img alt={"Selected Polygon"} className={"rounded-3 border-dark border border-2 "} src={image}/>*/}
                        <div className={"rounded-1 border-dark border border-2"}>
                            <div id={"map"}/>
                        </div>
                    </div>
                    <div className={"col-6 d-flex justify-content-center align-items-center"}>
                        <div className={"row"}>
                            <div className={"col-12 rounded-2 border border-2 border-dark h-100 d-flex justify-content-center align-items-center"}>
                                <table className={"table small"} style={{marginBottom: "0px"}}>
                                    <tbody>
                                    <tr>
                                        <th className={"align-middle"}>
                                            Kanalmodell:
                                        </th>
                                        <td className={"align-middle small "}>
                                        </td>
                                        <td className={"text-end"}>
                                            {/* Empirisch (Obstacle Path Model) */}
                                            <select disabled={false} className={"form-select align-right"}
                                                        id={"model"}
                                                        defaultValue={"Empirisch (Obstacle Shadowing nach ITU-R P.2040-3)"}
                                                        onChange={(e) => {
                                                            createJson()
                                                        }}
                                                        style={{fontSize: "small"}}>
                                                    {/* <option>Empirisch (Obstacle Shadowing nach ITU-R P.2040-3)</option> */}
                                                    <option>Empirisch (Starke Gebäudedämpfung)</option>
                                                    <option>Empirisch (Mittlere Gebäudedämpfung)</option>
                                                    <option>Empirisch (Schwache Gebäudedämpfung)</option>
                                                    {/* <option>Empirisch (Obstacle Shadowing Concrete)</option> */}
                                                    {/* <option>Empirisch (Obstacle Shadowing Brick)</option> */}
                                                    {/* <option>Empirisch (Obstacle Shadowing Plasterboard)</option> */}
                                                    {/* <option>Empirisch (Obstacle Shadowing OPAR)</option> */}
                                                    {/* <option>Empirisch (Obstacle Shadowing nach Sommer et al.)</option> */}
                                                    {/* <option>Machine Learning-basiert (DRaGon)</option> */}
                                                </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"}>
                                            Max. Anzahl Basisstationen:
                                        </th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td>
                                            <input className={"form-control align-right"} type={"number"}
                                                name={"baseStations"}
                                                id={"baseStations"}
                                                defaultValue={"10"} onChange={(e) => {
                                                checkNumBS();
                                                createJson()
                                            }}
                                                min={"1"} max={"10"} step={"1"}
                                                style={{fontSize: "small"}}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} scope={"row"}>Frequenzbereich:</th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td className={"align-middle text-end"}>
                                            3,7-3,8 GHz
                                            {/*<select disabled={true} className={"form-select align-right"}*/}
                                            {/*        id={"frequency"}*/}
                                            {/*        defaultValue={"3,7-3,8 GHz"}*/}
                                            {/*        onChange={() => {*/}
                                            {/*            frequencyChooserChanged();*/}
                                            {/*            blocksizeChooser26GChanged();*/}
                                            {/*            checkBandwidthExceedance();*/}
                                            {/*            checkMaxDate();*/}
                                            {/*            calculateCost();*/}
                                            {/*        }}*/}
                                            {/*        style={{fontSize: "small"}}>*/}
                                            {/*    <option>3,7-3,8 GHz</option>*/}
                                            {/*    <option>26 GHz</option>*/}
                                            {/*</select>*/}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} scope={"row"} style={{border: "0px"}}>Bandbreite
                                            [MHz]:<br/>
                                            <p className={"small fw-normal card-body border-dark text-center text-danger"}
                                            id={"bandwidth_exceedance_warning"} style={{display: "none"}}>
                                                Die Bundesnetzagentur sieht keine Begrenzung der beantragten Bandbreite
                                                vor,
                                                geht jedoch
                                                davon aus, dass die beantragten Bandbreiten auf Grund der aktuell
                                                verfügbaren
                                                Geräteparameter <u>maximal 800 MHz</u> betragen werden.
                                            </p>
                                        </th>
                                        <td className={"align-middle"} style={{border: "0px"}}>
                                        </td>
                                        <td className={"align-middle"} style={{border: "0px"}}>
                                            <input className={"form-control"} type={"number"} name={"bandwidth"}
                                                id={"B"}
                                                defaultValue={"100"} onChange={() => {
                                                checkBandwidthOrTime("B");
                                                checkBandwidthExceedance();
                                                calculateCost()
                                            }}
                                                min={"10"} max={"100"} step={"10"}
                                                style={{fontSize: "small"}}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} style={{fontWeight: "normal", border: "0px"}}>
                                            Blockgröße [MHz] (als
                                            Schrittweite der Bandbreite):
                                        </th>
                                        <td className={"align-middle"} style={{border: "0px"}}>
                                        </td>
                                        <td className={"align-right"} style={{border: "0px"}}>
                                            <select className={"form-select"} id={"blocksize_26GHz"} defaultValue={200}
                                                    onChange={() => {
                                                        blocksizeChooser26GChanged();
                                                        // frequencyChooserChanged();
                                                        checkBandwidthExceedance();
                                                        calculateCost();
                                                    }}
                                                    style={{fontSize: "small", display: "none"}}>
                                                <option>200</option>
                                                <option>100</option>
                                                <option>50</option>
                                            </select>
                                            <p className={"d-inline"} id={"blocksize_3GHz"}
                                            style={{fontSize: "small"}}>10</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} scope={"row"} style={{fontWeight: "normal"}}>
                                            Bandbreite automatisch bestimmen lassen:
                                        </th>
                                        <td className={"align-middle"}>
                                        </td>
                                        <td className={"align-middle"} style={{textAlign: "right"}}>
                                            <input
                                                className={"align-right"}
                                                type={"checkbox"}
                                                ref={checkbox}
                                                onChange={() => {
                                                    disableBandwidth()
                                                }}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <th className={"align-middle"} scope={"row"}>Laufzeit:</th>
                                        <td className={"align-middle"} style={{borderTop: "solid 1px"}}>
                                        </td>
                                        <td>
                                            <DateRangePicker className={"w-100 align-right"} onChange={timeRangeChange}
                                                            onCalendarClose={() => {
                                                                checkMaxDate();
                                                                calculateCost();
                                                                localStorage.setItem("timeRange", JSON.stringify(dates.current))
                                                            }}
                                                            value={timeRange} minDate={new Date()}/>
                                        </td>
                                    </tr>
                                    <tr style={{display: "none"}} id={"invalid_timespan"}>
                                        <th className={"align-middle"} scope={"row"}></th>
                                        <td colSpan={"2"}>
                                            <div id={"invalid_timespan_3"} style={{display: "none"}}
                                                className={"text-center align-right mt-0 pt-1 pb-1 mb-1 text-danger small"}>
                                                Achtung: Die Bundesnetzagentur wird Frequenzen auf Antrag für bis zu 10
                                                Jahre befristet zuteilen,
                                                jedoch maximal bis zum 31. Dezember 2040.
                                            </div>
                                            <div id={"invalid_timespan_26"} style={{display: "none"}}
                                                className={"text-center align-right mt-0 pt-1 pb-1 mb-1 text-danger small"}>
                                                Achtung: Die Bundesnetzagentur wird Frequenzen auf Antrag befristet
                                                zuteilen, auf die Möglichkeit der
                                                Verlängerung nach § 92 Abs. 2 TKG wird hingewiesen.
                                                Alle Zuteilungen sind längstens bis zum 31. Dezember 2040 befristet.
                                                Damit
                                                wird
                                                regulatorisch sichergestellt, dass für die Zeit ab dem 01. Januar 2041
                                                eine
                                                Entscheidung
                                                über die Anschlussnutzung des Frequenzbandes getroffen werden kann.
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} scope={"row"}>maximaler EIRP [dBm]: </th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td className={"align-middle"}>
                                            <select disabled={false} className={"form-select align-right"} id={"EIRP"}
                                                    defaultValue={'30'}
                                                    onChange={() => {
                                                        calculateCost();
                                                    }}
                                                    style={{fontSize: "small"}}>
                                                <option>0</option>
                                                <option>3</option>
                                                <option>6</option>
                                                <option>9</option>
                                                <option>12</option>
                                                <option>15</option>
                                                <option>18</option>
                                                <option>21</option>
                                                <option>24</option>
                                                <option>27</option>
                                                <option>30</option>
                                                <option>33</option>
                                                <option>36</option>
                                                <option>39</option>
                                                <option>40</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"}  style={{borderBottom: "none"}} scope={"row"}>Antennentyp:
                                        </th>
                                        <td className={"align-middle small"} style={{borderBottom: "none"}}>
                                        </td>
                                        <td className={"align-middle text-end"} style={{borderBottom: "none"}}>
                                            Rundstrahler
                                            {/*<select disabled={true} className={"form-select align-right"}*/}
                                            {/*            id={"antennatype"}*/}
                                            {/*            style={{fontSize: "small"}}>*/}
                                            {/*        <option>Rundstrahler</option>*/}
                                            {/*</select>*/}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <th className={"align-middle"} scope={"row"}>Azimuthwinkel [°]: <br/><small>(nur für
                                            Sektorantenne
                                            verfügbar)</small>
                                        </th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td className={"align-middle"}>
                                            <MultiSelect disabled={!selectedAntennas.includes("Sektorantenne")}
                                                        className={"w-100"}
                                                        id={"azimuth"}
                                                        value={selectedAzimuths}
                                                        options={azimuths}
                                                        onChange={(e) => {
                                                            setSelectedAzimuths(e.value)
                                                        }}
                                                        style={{fontSize: "small"}}/>
                                        </td>
                                    </tr> */}
                                    {/*<tr>*/}
                                    {/*    <th className={"align-middle"} scope={"row"}>*/}
                                    {/*        Grenzwert an der Grundstücksgrenze: <br/><small>(Kein Grenzwert, aber*/}
                                    {/*        Beschränkung auf 10W EIRP Sendeleistung)</small>*/}
                                    {/*    </th>*/}
                                    {/*    <td></td>*/}
                                    {/*    <td className={"align-middle"} style={{alignItems: "center"}}>*/}
                                    {/*        <input*/}
                                    {/*            id={"grenzwert"}*/}
                                    {/*            className={"range-input"}*/}
                                    {/*            type={"range"}*/}
                                    {/*            min="0"*/}
                                    {/*            max="20"*/}
                                    {/*            defaultValue={10}*/}
                                    {/*            onChange={(e) => {*/}
                                    {/*                document.getElementById("grenzwert_value").innerText = e.target.value; // Update span with current value*/}
                                    {/*                calculateCost();*/}
                                    {/*            }}*/}
                                    {/*            style={{verticalAlign: "middle", marginRight: "5px", width: "90%"}}*/}
                                    {/*        />*/}
                                    {/*        <span id={"grenzwert_value"} className={"align-middle"} style={{*/}
                                    {/*            fontSize: "small",*/}
                                    {/*            minWidth: "20px",*/}
                                    {/*            textAlign: "center"*/}
                                    {/*        }}>{10}</span>*/}
                                    {/*    </td>*/}
                                    {/*</tr>*/}
                                    </tbody>
                                </table>
                            </div>

                            <hr className="my-4" style={{ border: "none", background: "none", boxShadow: "none", height: "0px" }} />

                            <div className={"col-12 rounded-2 border border-2 border-dark h-100 d-flex justify-content-center align-items-center"}>
                                <table className={"table small"} style={{marginBottom: "0px"}}>
                                    <tbody>
                                    <tr>
                                        <th className={"align-middle"}>Fläche [km<sup>2</sup>]:</th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td style={{textAlign: "right"}}>
                                            <p className={"d-inline"} id={"area"}>{area}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"}><span
                                            title={"Vgl. Angaben des Statistischen Bundesamtes und des Umweltbundesamtes zur Flächennutzung, abrufbar unter www.umweltbundesamt.de / „Struktur der Flächennutzung“."}>Anteil Siedlungs- und Verkehrsfläche [%] <small>(Automatisiert berechnet)</small>:</span><img
                                            alt={"loading"} src={loader} id={"loader1"} style={{visibility: "hidden"}}/>
                                        </th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td><input className={"form-control align-right"} type={"number"}
                                                name={"percent_settlement"}
                                                onChange={a1Changed}
                                                id={"a1"}
                                                min={"0"} max={"100"} step={"0.1"} defaultValue={"100"}
                                                style={{fontSize: "small"}}
                                                disabled={false}/></td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"}><span
                                            title={"Vgl. Angaben des Statistischen Bundesamtes und des Umweltbundesamtes zur Flächennutzung, abrufbar unter www.umweltbundesamt.de / „Struktur der Flächennutzung“."}>Anteil Andere Flächen [%] <small>(Automatisiert berechnet)</small>:</span><img alt={"loading"}
                                                                                                    src={loader}
                                                                                                    id={"loader2"}
                                                                                                    style={{visibility: "hidden"}}/>
                                        </th>
                                        <td className={"align-middle small"}>
                                        </td>
                                        <td><input className={"form-control align-right"} type={"number"}
                                                name={"percent_settlement"}
                                                id={"a2"}
                                                onChange={a2Changed}
                                                min={"0"} max={"100"} step={"0.1"} defaultValue={"0"}
                                                style={{fontSize: "small"}}
                                                disabled={false}/></td>
                                    </tr>
                                    <tr style={{display: "none"}} id={"invalid_area"}>
                                        <td colSpan={"2"}>
                                            <div
                                                className={"text-center align-right mt-0 pt-1 pb-1 mb-1 text-danger small"}>
                                                Achtung: Flächenanteile vom <a
                                                href={"https://gdz.bkg.bund.de/index.php/default/wfs-corine-land-cover-5-ha-stand-2018-wfs-clc5-2018.html"}
                                                className={"link"}
                                                target={"_blank"} rel={"noreferrer"}>Bundesamt für Kartopraphie und
                                                Geodäsie</a> nicht abrufbar. Bitte manuell überprüfen und eingeben!
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th className={"align-middle"} style={{borderBottom: "none"}}>Frequenzzuteilungsgebühr:
                                        </th>
                                        <td className={"align-middle small"} style={{borderBottom: "none"}}>
                                        </td>
                                        <td style={{textAlign: "right", borderBottom: "none"}}>
                                            <p className={"d-inline"} id={"kosten"}>0,00 €</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default OutdoorPlaningCalculation;
